import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';

import { FormItem } from '@/interfaces/lib/model';
import { getSignalWordsList } from '@/lib/formItem';
import { required } from '@/lib/rule';
import { VForm } from 'vuetify/lib/components';
import sharedMessages from '@/lib/shared-messages';
import { SignalWordId } from '@/lib/enum/SignalWordId';
import { readUserLocale } from '@/store/main/getters';
import store from '@/store';
import { Locale } from '@/interfaces/api/general/language';


export default /*#__PURE__*/_defineComponent({
  __name: 'SdsSection2LabelSignalWordsForm',
  props: {
  isEditing: {
    type: Boolean,
    default: false,
  },
  isValid: {
    type: Boolean,
    default: false,
  },
  signalWordId: {
    type: String,
    default: null,
  },
},
  emits: ["update:isValid", "update:signalWordId"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'update:isValid', data: boolean): void;
  (e: 'update:signalWordId', data: string): void;
}), expose: any, slots: any, attrs: any }) {

const locale = readUserLocale(store);



const form = ref<InstanceType<typeof VForm> | null>(null);



const updateIsValid = (e: boolean) => {
  emits('update:isValid', e);
};

const updateSignalWordId = (e: string | FormItem | null) => {
  // If signal words is not selected, e is null
  // And, We do not update value
  // It means that the user can save without selecting signal words but, actually,
  // It save the previous value displayed before deleting

  if (typeof e == 'string') {
    emits('update:signalWordId', e);
  } else if (e && e.value) {
    emits('update:signalWordId', String(e.value));
  }
};

const toItem = (signalWordId: string, locale: Locale) =>
  SignalWordId.value(signalWordId, locale);

onMounted((): void => {
  if (form.value) {
    form.value.validate();
  }
});

return { __sfc: true,locale, form, emits, updateIsValid, updateSignalWordId, toItem, getSignalWordsList, required, VForm, sharedMessages }
}

})